var _rect, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";
function SvgCharityDonation(props) {
  var _id = useUniqueInlineId();
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#E8B0B2",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#".concat(_id, ")")
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.002 16.952c0 .118-.023.24-.023.367 0 4.424-5.61 9.384-9.615 12.24a2.35 2.35 0 01-2.739 0 55.895 55.895 0 01-2.747-2.131 32.254 32.254 0 01-1.954-1.745c-2.663-2.557-4.882-5.563-4.882-8.36v-.367h-.04c0-1.54-.09-3.3 1.056-4.456 2.109-2.149 6.104-2.099 8.386-.14l1.562 1.36 1.563-1.36a5.677 5.677 0 012.216-1.179 5.602 5.602 0 012.498-.1c1.114.204 2.548.363 3.41 1.238 1.144 1.174 1.33 3.096 1.304 4.633h.005z",
    fill: "#BF5C5C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.002 15.995c0 .118-.022.24-.022.367 0 4.425-5.611 9.384-9.615 12.24a2.35 2.35 0 01-2.74 0 53.32 53.32 0 01-2.747-2.13 32.222 32.222 0 01-1.953-1.746c-2.655-2.561-4.892-5.567-4.892-8.35v-.367h-.031a5.952 5.952 0 01.841-3.209 5.78 5.78 0 012.414-2.225 5.63 5.63 0 013.211-.527 5.677 5.677 0 012.976 1.341l1.562 1.36 1.563-1.36a5.678 5.678 0 012.969-1.33 5.63 5.63 0 013.2.526 5.778 5.778 0 012.41 2.215c.578.96.873 2.069.85 3.195h.004z",
    fill: "#F77777"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.283 10.124L13.925 24.721c-2.655-2.556-4.892-5.562-4.892-8.345v-.367h-.031a5.952 5.952 0 01.841-3.209 5.78 5.78 0 012.414-2.225 5.63 5.63 0 013.211-.527 5.677 5.677 0 012.976 1.341l1.562 1.36 1.563-1.36a5.675 5.675 0 012.219-1.17 5.602 5.602 0 012.495-.095z",
    fill: "#FF8787"
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: _id
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(9 10)",
    d: "M0 0h22v20H0z"
  })))));
}
export default SvgCharityDonation;